// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import {
    filterContacts,
    loadContacts,
    showDeleteContactPrompt,
    deletePromptReset,
    removeContact,
} from '../../redux/reducers/contacts';
import List from '../../components/Contacts/List';
import Filter from '../../components/shared/Filter';

import Loader from '../../components/Loader/Loader';
import DeleteContactModal from '../../components/Contacts/DeleteModal';
import Pagination from '../../components/shared/Pagination';

import { colors } from '../../shared/styles';

const ContactsWrapper = styled.div`
    display: flex;
    position: relative;

    .list {
        background: ${colors.white};
        flex-grow: 1;
    }

    .list-wrapper {
        background: ${colors.white};
        height: calc(100vh - 152px);
        overflow: hidden;
    }
`;

class Contacts extends Component {
    onFilterChange: Function;
    onFilterReset: Function;
    onFilterSubmit: Function;
    onPageChange: Function;
    onDelete: Function;
    confirmDelete: Function;
    deletePromptReset: Function;
    refresh: Function;

    state = {
        refreshing: false,
    };

    constructor(props) {
        super(props);

        this.onFilterChange = this.onFilterChange.bind(this);
        this.onFilterReset = this.onFilterReset.bind(this);
        this.onFilterSubmit = this.onFilterSubmit.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.deletePromptReset = this.deletePromptReset.bind(this);
        this.refresh = this.refresh.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(loadContacts(1));
    }

    onFilterChange(e) {
        this.props.dispatch(filterContacts(e.target.value));
    }

    onFilterReset() {
        this.props.dispatch(filterContacts(''));

        this.props.dispatch(loadContacts(1));
    }

    onFilterSubmit(e) {
        e.preventDefault();

        this.props.dispatch(loadContacts(1));
    }

    onPageChange(pageNo) {
        this.props.dispatch(loadContacts(pageNo));
    }

    onDelete(contact) {
        const contactName = `${contact.contactForenames} ${contact.contactSurname}`;

        this.props.dispatch(
            showDeleteContactPrompt(contact.contactId, contactName)
        );
    }

    confirmDelete() {
        const {
            dispatch,
            deletePrompt: { contactId, contactName },
        } = this.props;

        dispatch(removeContact(contactId, contactName)).then(() => {
            this.refresh();
        });
    }

    deletePromptReset() {
        this.props.dispatch(deletePromptReset());
    }

    refresh() {
        this.setState({
            refreshing: true,
        });

        setTimeout(() => {
            this.props.dispatch(loadContacts(1));
            this.setState({
                refreshing: false,
            });
        }, 500);
    }

    render() {
        const {
            contacts,
            filter,
            isFetching,
            deletePrompt,
            pagination,
            total,
            fetchingTime,
        } = this.props;
        const { refreshing } = this.state;

        return (
            <ContactsWrapper>
                <DeleteContactModal
                    isOpen={deletePrompt.visible}
                    removing={deletePrompt.removing}
                    contactName={deletePrompt.contactName}
                    onCancel={this.deletePromptReset}
                    onConfirmDelete={this.confirmDelete}
                />
                <Filter
                    filter={filter}
                    onFilterChange={this.onFilterChange}
                    onFilterReset={this.onFilterReset}
                    onFilterSubmit={this.onFilterSubmit}
                    total={total}
                    fetchingTime={fetchingTime}
                    suffix={'Contact'}
                />
                <div className="list">
                    <div className="list-wrapper">
                        {(isFetching || !contacts) &&
                            <Loader message="Loading contacts, please wait..." />}
                        {refreshing &&
                            <Loader message="Refreshing, please wait..." />}
                        {!isFetching &&
                            contacts &&
                            !refreshing &&
                            <List
                                contacts={contacts}
                                onDelete={this.onDelete}
                            />}
                    </div>
                    <Pagination
                        onPageChange={this.onPageChange}
                        pagination={pagination}
                    />
                </div>
            </ContactsWrapper>
        );
    }
}

const mapStateToProps = state => {
    const list = state.contacts.list;
    const remove = state.contacts.remove;

    return {
        errorFetching: list.error,
        filter: list.filter,
        isFetching: list.fetching,
        contacts: list.contacts,
        deletePrompt: {
            contactId: remove.contactId,
            contactName: remove.contactName,
            removing: remove.removing,
            visible: Boolean(remove.contactId && remove.contactName),
        },
        pagination: list.pagination,
        total: list.pagination.total,
        fetchingTime: list.fetchingTime,
    };
};

export default connect(mapStateToProps)(Contacts);



// WEBPACK FOOTER //
// ./src/containers/Contacts/Contacts.js